export enum AllergiesType {
  MEDICATION = 'Medikamente',
  FOOD = 'Lebensmittel',
  OTHERS = 'Sonstiges',
}
